<template>
  <!-- 大事记 index -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <label style="margin-right: 8px; font-size: 14px" for>年份:</label>
        <el-select
          v-model="selectYearValue"
          placeholder="全部"
          @change="handleBannerList"
        >
          <el-option
            v-for="(item, index) in yearList"
            :key="index"
            :label="index == 0 ? '全部' : item + ' 年'"
            :value="item"
          />
        </el-select>
      </div>
      <div>
        <el-input
          placeholder="请输入"
          v-model.trim="searchInfo"
          style="min-width: 300px"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right">
        <el-button
          v-on:click="addActivity"
          type="primary"
          style="width: 80px"
          v-if="isManage"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          v-if="isManage"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column type="index" label="序号" align="center" width="60">
        </el-table-column>
        <el-table-column prop="id" label="大事记ID" align="center" width="120">
        </el-table-column>
        <el-table-column prop="subtitle" label="大事记标题" align="center">
        </el-table-column>
        <el-table-column prop="year" label="年份" align="center" width="120">
        </el-table-column>
        <el-table-column
          prop="mouth"
          label="大事记时间"
          align="center"
          width="120"
        >
        </el-table-column>

        <el-table-column prop="bookId" width="120" align="center" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == '0'" type="success"
              >发布中</el-tag
            >
            <el-tag v-if="scope.row.status == '1'" type="info">未发布</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="operate"
          width="260"
          align="center"
          label="操作"
          v-if="isManage"
          :key="Math.random()"
        >
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              title=""
              width="260"
              trigger="click"
              @show="handleClickView(scope.row)"
            >
              <el-descriptions
                class="margin-top"
                title=""
                :column="1"
                size="small"
                border
              >
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-date"></i>
                    年份
                  </template>
                  {{ previewForm.year }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-date"></i>
                    大事记时间
                  </template>
                  {{ previewForm.mouth }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    地点
                  </template>
                  {{ previewForm.title }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-notebook-2"></i>
                    内容
                  </template>
                  {{ previewForm.subtitle }}
                </el-descriptions-item>
              </el-descriptions>
              <i class="el-icon-view" slot="reference"></i>
            </el-popover>
            <i class="el-icon-edit" @click="handleEditClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import bannerApi from '@/api/bigEvent/index.js'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import { checkRole } from '../../utils/auth'
export default {
  data () {
    return {
      loading: false,
      selectYearValue: '全部',
      isManage: false, // 是否是管理用户
      optionStatus: '',
      previewForm: {},
      searchInfo: '',
      options: [],
      yearList: [], // 年份列表
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleYearSelectList()
    this.handleBannerList()
    this.isManage = checkRole(['manage'])
  },
  methods: {
    ...mapRequestActions(bannerApi),

    /**
     * 获取banner图片列表
     */
    handleBannerList () {
      this.eventListAction({
        year: this.selectYearValue === '全部' ? '' : this.selectYearValue,
        subtitle: this.searchInfo,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then((res) => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },
    /**
     * 获取年限下拉列表
     */
    async handleYearSelectList () {
      const resultData = await this.getYearSelectAction()
      if (resultData.status) {
        this.yearList = resultData.result || []
        this.yearList.unshift('全部')
      } else {
        this.$message.error(resultData.errorMsg)
      }
    },

    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleBannerList()
    },

    searchHandler () {
      this.handleBannerList()
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 预览
     */
    handleClickView (e) {
      this.previewForm = e || {}
    },
    /**
     * 新增
     */
    addActivity () {
      this.$router.push('/big-event-add')
    },
    /**
     * 编辑
     */
    handleEditClick (item) {
      this.$router.push({
        path: '/big-event-edit',
        query: { id: item.id }
      })
    },
    /**
     * 删除 全选操作
     */
    delClick () {
      const _this = this
      MessageBox.confirm('此操作将永久删除该大事记, 是否继续?', '提示').then(
        () => {
          const longIds = _this.selectArr.map((item) => item.id)
          this.deleteBigeventAction({ longIds }).then((res) => {
            if (res.status) {
              _this.$message({
                type: 'success',
                message: '删除成功'
              })
              _this.handleBannerList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        }
      )
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该大事记, 是否继续?', '提示').then(
        () => {
          const longIds = [item.id]
          this.deleteBigeventAction({ longIds }).then((res) => {
            if (res.status) {
              _this.$message.success('删除成功')
              _this.handleBannerList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        }
      )
    }
  }
}
</script>

<style lang='less' scoped>
@import "./index.less";
</style>
